import React, { Component, Fragment } from "react";
import AppContext from "../../contexts/AppContext";
import { records } from "../../services/post";

class Posts extends Component {
    state = {
        items: [],
    };

    componentDidMount() {
        records()
            .then(response => {
                this.setState({
                    items: response.data,
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    render() {
        return (
            <div className="card latest-article">
                <div className="card-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h4 className="card-header-title">Latest Articles</h4>
                        </div>
                        <div className="col-auto">
                            <a target="_blank" className="small" href="/library/articles">
                                View all
                            </a>
                        </div>
                    </div>
                </div>

                <div className="card-body pt-4 pl-4 pr-4 pb-2">
                    {this.state.items.map((item, index) => {
                        return (
                            <Fragment>
                                <div className="row mt-3 align-items-center" key={index}>
                                    <div className="col d-flex">
                                        <div className="avatar-xl mr-3">
                                            <img
                                                src={item.image}
                                                alt=""
                                                className="avatar-img rounded article-img"
                                            />
                                        </div>
                                        <div>
                                            <h4 className="mb-1 mt-0">
                                                <a
                                                    target="_blank"
                                                    href={item.link}
                                                >
                                                    {item.title}
                                                </a>
                                            </h4>

                                            <small className="text-muted">
                                                {item.date}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <hr/>
                            </Fragment>
                        );
                    })}
                </div>
            </div>
        );
    }
}
Posts.contextType = AppContext;
export default Posts;



// WEBPACK FOOTER //
// ./src/components/blog/Posts.js